import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import DealsCard from './DealsCard'
import { Droppable } from 'react-beautiful-dnd';
import { getDealsApi, } from "api/SalesApi"


const Container = styled.div`
  margin : 8px;
  border : 1px solid lightgray;
  border-radius : 4px;
  min-width : 300px;
  display : flex;
  flex-direction : column;
  background-color : rgb(232, 240, 254);
`;
const Title = styled.div`
  padding : 8px;
  margin-bottom : 0px;
  font-size: 16px;
  font-weight: bold;
`;
const DealsList = styled.div`
  padding : 8px;
  flex-grow : 1;
  transition : background-color 0.2s ease;
  background-color : ${props => (props.isDraggingOver ? 'rgb(162, 195, 250)' : 'rgb(232, 240, 254)')};
  min-height : 100px;
`;
const HorizontalLine = styled.div`
  width : 100%;
  height : 1px;
  background-color : lightgray;
`;



export default function DealsStages({ stage, setShowDealModal }) {
  return (
    <Container>
      <Title>{stage.label}</Title>
      <HorizontalLine />
      <Droppable
        droppableId={stage.id}
      >
        {(provided, snapshot) => (
          <DealsList
            ref={provided.innerRef}
            {...provided.droppableProps}
            isDraggingOver={snapshot.isDraggingOver}
          >
            {
              // Deals should be mapped here
              stage.deals.length > 0 && stage.deals.map((deal, index) => (
                <DealsCard index={index} deal={deal} setShowDealModal={setShowDealModal} />
              )
              )
            }
            {provided.placeholder}
          </DealsList>
        )}
      </Droppable>
    </Container>
  )
}
